module.exports = __webpack_public_path__ + "static/media/Affiliate-BG_mobile.f3e963be.jpg";